var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMongodb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68,
    height: 150,
    viewBox: "0 0 68 150",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "mongodb"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M33.5264 0.409668L37.5664 7.92785C38.4747 9.31525 39.4586 10.5433 40.6176 11.6869C44.0156 15.0117 47.1828 18.5601 50.0978 22.308C56.943 31.2136 61.5601 41.1035 64.8574 51.7996C66.8348 58.3334 67.9086 65.0361 67.989 71.8137C68.3202 92.0762 61.3094 109.475 47.1743 123.935C44.8751 126.228 42.3912 128.331 39.7472 130.225C38.3469 130.225 37.6847 129.161 37.1075 128.181C36.0565 126.365 35.357 124.37 35.045 122.299C34.5483 119.848 34.2218 117.396 34.3827 114.865V113.721C34.2691 113.478 33.0344 0.986187 33.5264 0.409668V0.409668Z",
    fill: "#599636"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M33.5262 0.161252C33.3607 -0.166849 33.1951 0.0815705 33.0295 0.240934C33.11 1.88144 32.5328 3.34383 31.6293 4.7406C30.6358 6.128 29.3207 7.19198 28.0009 8.33565C20.6684 14.6258 14.8971 22.2237 10.2753 30.7215C4.12546 42.1581 0.955948 54.415 0.0571304 67.3188C-0.354433 71.9731 1.54254 88.3969 3.02323 93.1356C7.06317 105.716 14.3199 116.257 23.7197 125.407C26.0282 127.61 28.4976 129.653 31.0521 131.617C31.7948 131.617 31.8753 130.961 32.0456 130.473C32.3712 129.43 32.6194 128.365 32.7883 127.286L34.444 115.034L33.5262 0.161252Z",
    fill: "#6CAC48"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M37.5663 135.203C37.7319 133.328 38.6402 131.772 39.6289 130.22C38.6354 129.813 37.8975 129.002 37.3203 128.097C36.8227 127.241 36.4107 126.338 36.0904 125.402C34.9361 121.971 34.6901 118.371 34.359 114.865V112.742C33.9474 113.07 33.8622 115.845 33.8622 116.258C33.6215 119.963 33.1252 123.648 32.3768 127.286C32.1308 128.758 31.9653 130.225 31.0522 131.533C31.0522 131.697 31.0522 131.861 31.1327 132.105C32.6181 136.436 33.0249 140.846 33.2756 145.341V146.982C33.2756 148.941 33.1952 148.528 34.8367 149.185C35.499 149.428 36.237 149.513 36.8993 150C37.396 150 37.4764 149.592 37.4764 149.264L37.2304 146.569V139.051C37.15 137.739 37.396 136.436 37.5616 135.208L37.5663 135.203Z",
    fill: "#C2BFBF"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMongodb);
export default __webpack_public_path__ + "static/media/mongodb.c5fb3eb692cea2ebc0ed1583948b613e.svg";
export { ForwardRef as ReactComponent };